import React from 'react';
import { NavLink } from "react-router-dom";

const Capabilities_section = () => {
  return (
   
    <section className="capabilities-section">
    <div className="page-wrap my-paroller">
        <div className="row block1">
            <div className="col-3 item-wrapper bluebg wow fadeInUp duration animated" data-wow-duration="500ms" data-wow-delay="300ms">
                <figure>
                    <img src={`/img/svg/cxaudit-metrics.svg`} alt="CX Audit and Metrics"/>
                </figure>
                <h3>CX Audit and Metrics</h3>
                <p>Measure Customer Experience to improve Customer Satisfaction, NPS, and more.</p>
                <span className="btn-wrapper"><NavLink to={`/cxnow/cxaudit`} className="btn">More on CX Audit <i className="fal fa-long-arrow-right"></i></NavLink></span>

            </div>
            <div className="col-3 item-wrapper greenbg wow fadeInUp duration animated" data-wow-duration="500ms" data-wow-delay="600ms">
                <figure>
                    <img src={`/img/svg/customer-journey-img.svg`} alt="Customer Journey"/>
                </figure>
                <h3>Customer Journey</h3>
                <p>Discover and aggrandize the aspirations of the customer throughout the journey.</p>
                <span className="btn-wrapper"><NavLink to={`/cxnow/customer-journey`} className="btn">More on Customer Journey
                        <i className="fal fa-long-arrow-right"></i></NavLink></span>
            </div>
            <div className="col-3 item-wrapper pinkbg wow fadeInUp duration animated" data-wow-duration="500ms" data-wow-delay="900ms">
                <figure>
                    <img src={`/img/svg/customer-voice-img.svg`} alt="Customer Voice"/>
                </figure>
                <h3>Customer Voice</h3>
                <p>Develop metrics, measure the impact of anecdotal, and analytical Voice of Customer.</p>
                <span className="btn-wrapper"><NavLink to={`/cxnow/customer-voice`} className="btn">More on Customer Voice <i className="fal fa-long-arrow-right"></i></NavLink></span>
            </div>
            <div className="col-3 item-wrapper orangebg wow fadeInUp duration animated" data-wow-duration="500ms" data-wow-delay="1200ms">
                <figure>
                    <img src={`/img/svg/digital-maturity-img.svg`} alt="Indicial Digital Maturity"/>
                </figure>
                <h3>Indicial Digital Maturity</h3>
                <p>Leverage from Indicial diagnostics to gauge CX &amp; digital transformation maturity.</p>
                <span className="btn-wrapper"><NavLink to={`/indicial`} className="btn">More on Indicial Digital Maturity <i className="fal fa-long-arrow-right"></i></NavLink></span>
            </div>
        </div>

    </div>
</section>
  )
}

export default Capabilities_section
